// extracted by mini-css-extract-plugin
module.exports = {"row":"Home_row___CqSC","home":"Home_home__1JXvv","new_version":"Home_new_version__3K3XB","header":"Home_header__wDYyq","main":"Home_main__2u8U0","footer":"Home_footer__3oZSW"};